import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { ReactiveFormsModule } from "@angular/forms";
import { CalendarModule } from "ion2-calendar";
import { SharedheaderModule } from "../../header/sharedheader/sharedheader.module";

import { IonicModule } from "@ionic/angular";

import { LessonParameterModalPage } from "./lessonParameter-modal.page";

const routes: Routes = [
  {
    path: "",
    component: LessonParameterModalPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedheaderModule,
    NgxExtendedPdfViewerModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    //CalendarModule,
  ],
  declarations: [LessonParameterModalPage],
})
export class LessonParameterModalPageModule {}
